(function () {
  'use strict';

  angular
    .module('layoverSummaryReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('layoverSummaryReport', {
        url: '/layover-summary-report',
        views:{
          'layoverSummaryReportView':{
            templateUrl: 'layover-summary-report/views/layover-summary-report.tpl.html',
            controller: 'LayoverSummaryReportCtrl',
            controllerAs: 'layoverSummaryReport'
          }
        }
      });
  }
}());
